import React from 'react';
import { motion } from 'framer-motion';
const projects = [{
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80',
  label: 'Construcción'
}, {
  image: 'https://images.unsplash.com/photo-1484154218962-a197022b5858?auto=format&fit=crop&q=80',
  label: 'Remodelación'
}, {
  image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&q=80',
  label: 'Terminaciones'
}, {
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=80',
  label: 'Ampliación'
}, {
  image: 'https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80',
  label: 'Mejoras'
}, {
  image: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80',
  label: 'Proyecto finalizado'
}];
export function Gallery() {
  return <section id="galeria" className="py-20 bg-white" data-id="element-67">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-68">
        <div className="text-center mb-16" data-id="element-69">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-70">
            Trabajos realizados
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-lg text-gray-600" data-id="element-71">
            Revisa algunos ejemplos de trabajos y solicita orientación para tu
            proyecto.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-72">
          {projects.map((project, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative overflow-hidden rounded-2xl aspect-[4/3] bg-gray-100" data-id="element-73">
              <img src={project.image} alt={`Proyecto de ${project.label.toLowerCase()}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-74" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/80 via-navy/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-75"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300" data-id="element-76">
                <span className="inline-block bg-orange text-white text-sm font-semibold px-3 py-1 rounded-full" data-id="element-77">
                  {project.label}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}